import { Button, Form, Input, Modal, Tabs, Upload } from "antd";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import BtnEditSvg from "../Button/btnEditSvg";
import { useDispatch, useSelector } from "react-redux";
import { updateEmploymentStatus } from "../../../redux/rtk/features/employemntStatus/employmentStatusSlice";
import baseUrl from "../../../utils/baseUrl";

const { TabPane } = Tabs;

const EmploymentStatusEditPopup = ({ data }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fileList, setFileList] = useState([]);
  const { id } = useParams("id");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { loading } = useSelector((state) => state.employmentStatus);
  const navigate = useNavigate();

  // 🧩 Extract translations for EN and NL
  const enTranslation = data?.translations?.find((t) => t.languageCode === "en") || {};
  const nlTranslation = data?.translations?.find((t) => t.languageCode === "nl") || {};

  const initialValues = {
    name_en: enTranslation.name || "",
    description_en: enTranslation.description || "",
    name_nl: nlTranslation.name || "",
    description_nl: nlTranslation.description || "",
    colourValue: data?.colourValue || "#ffffff",
  };

  // ✅ Ensure form fields prefill every time modal opens
  useEffect(() => {
    if (isModalOpen && data) {
      form.setFieldsValue(initialValues);
    }
  }, [isModalOpen, data]);

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const onFinish = async () => {
    try {
      const values = await form.validateFields();
      const formData = new FormData();

      formData.append("colourValue", values.colourValue);
      formData.append("name_en", values.name_en);
      formData.append("description_en", values.description_en || "");
      formData.append("name_nl", values.name_nl);
      formData.append("description_nl", values.description_nl || "");

      const imageFile = fileList?.[0]?.originFileObj;
      if (imageFile) {
        formData.append("image", imageFile);
      }

      const resp = await dispatch(updateEmploymentStatus({ id: data.id, values: formData }));

      if (resp.payload?.message === "success") {
        toast.success("Category updated successfully");
        setIsModalOpen(false);
        navigate(0); // refresh current page to show latest values
      }
    } catch (error) {
      toast.error("Please fill all required fields correctly!");
    }
  };

  return (
    <>
      <button onClick={showModal}>
        <BtnEditSvg size={30} />
      </button>

      <Modal
        title="Edit Category (Multilingual)"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        width={650}
      >
        <Form
          form={form}
          layout="horizontal"
          onFinish={onFinish}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 16 }}
        >
          {/* Tabs for English & Dutch */}
          <Tabs defaultActiveKey="en">
            <TabPane tab="English" key="en">
              <Form.Item
                label="Name (EN)"
                name="name_en"
                rules={[{ required: true, message: "Please enter English name!" }]}
              >
                <Input placeholder="Electrician" />
              </Form.Item>

              <Form.Item label="Description (EN)" name="description_en">
                <Input.TextArea placeholder="Description" />
              </Form.Item>
            </TabPane>

            <TabPane tab="Dutch" key="nl">
              <Form.Item
                label="Name (NL)"
                name="name_nl"
                rules={[{ required: true, message: "Please enter Dutch name!" }]}
              >
                <Input placeholder="Elektricien" />
              </Form.Item>

              <Form.Item label="Description (NL)" name="description_nl">
                <Input.TextArea placeholder="Beschrijving" />
              </Form.Item>
            </TabPane>
          </Tabs>

          {/* Color Input */}
          <Form.Item
            label="Color Code"
            name="colourValue"
            rules={[{ required: true, message: "Please enter a color code!" }]}
          >
            <Input placeholder="#00FF00" />
          </Form.Item>

          {/* Image Upload */}
          <Form.Item label="Image">
            {data?.image && fileList.length === 0 && (
              <div style={{ marginBottom: 10 }}>
                <img
                  src={`${baseUrl}/files/${data.image}`}
                  alt="Current"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                  }}
                />
              </div>
            )}
            <Upload
              listType="picture"
              maxCount={1}
              beforeUpload={() => false}
              fileList={fileList}
              onChange={({ fileList }) => setFileList(fileList)}
            >
              <Button>Select New Image</Button>
            </Upload>
          </Form.Item>

          {/* Submit */}
          <Form.Item wrapperCol={{ offset: 6, span: 12 }}>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Update Now
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default EmploymentStatusEditPopup;
